import { combineReducers } from '@reduxjs/toolkit'
import filters from './filtering'
import tracking from './tracking'
import subscription from './subscription'
import viewBy from './viewBy'
import user from './user'
import error from './error'
import currency from './currency'
import audienceProfiler from './audienceProfiler'
import pagination from './pagination'
import compareBy from './compareBy'
import featureFlag from './featureFlag'
import KBQ from './KBQ'
import brandColors from './brandColors'

const rootReducer = combineReducers({
  filters,
  tracking,
  subscription,
  viewBy,
  audienceProfiler,
  user,
  error,
  currency,
  pagination,
  compareBy,
  featureFlag,
  KBQ,
  brandColors,
})

export default rootReducer
